import {
	SETUP_SETTINGS_TOUR,
    SETUP_TEAMHOME_TOUR,
    CLEANUP_SETTINGS_TOUR,
    CLEANUP_TEAMHOME_TOUR
} from 'redux/reduxConstants';

export function setupSettingsTour() {
    return { type: SETUP_SETTINGS_TOUR };
}

export function cleanupSettingsTour() {
    return { type: CLEANUP_SETTINGS_TOUR };
}

export function setupTeamHomeTour(userName: string) {
    return { type: SETUP_TEAMHOME_TOUR, userName };
}

export function cleanupTeamHomeTour() {
    return { type: CLEANUP_TEAMHOME_TOUR };
}